import { render } from "./windowInput.vue?vue&type=template&id=2410b0c8&scoped=true"
import script from "./windowInput.vue?vue&type=script&lang=js"
export * from "./windowInput.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2410b0c8"

export default script